import { render, staticRenderFns } from "./ComparativeIcon.vue?vue&type=template&id=0507637f&scoped=true"
import script from "./ComparativeIcon.vue?vue&type=script&lang=js"
export * from "./ComparativeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507637f",
  null
  
)

export default component.exports